// Import reducers
import { configureStore } from '@reduxjs/toolkit'
import appReducer from './appSlice'

// root reducer
const rootReducer = {
  app: appReducer,
}

// app store
const store = configureStore({
  reducer: rootReducer,
  devTools: SP.REACT_APP_DEV_TOOLS_ENABLE == 1 ? true : false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export default store

/**
 * @typedef {ReturnType<typeof store['getState']>} RootState
 * @typedef {store['dispatch']} AppDispatch
 */
